module.exports = __webpack_public_path__ + "img/platziexchange.b0f5e48b.png";